export default class CookieService {
    static get(cookieName) {
        var nameEncoded = encodeURIComponent(cookieName) + '=';
        var cookieArray = document.cookie.split(';');

        for (var i = 0; i < cookieArray.length; i++) {
            var cookie = cookieArray[i].trim();
            if (cookie.indexOf(nameEncoded) === 0) {
                return decodeURIComponent(cookie.substring(nameEncoded.length, cookie.length));
            }
        }

        return null;
    }

    static set(cookieName, cookieValue, daysToExpire) {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + daysToExpire);

        var cookieString =
            encodeURIComponent(cookieName) +
            '=' +
            encodeURIComponent(cookieValue) +
            '; expires=' +
            expirationDate.toUTCString() +
            '; path=/';

        document.cookie = cookieString;
    }

    static delete(cookieName) {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() - 1);
        const cookieString = encodeURIComponent(cookieName) + '=; expires=' + expirationDate.toUTCString() + '; path=/';
        document.cookie = cookieString;
    }
}